import React from 'react';
import styles from './ResourcesSection.module.scss';
import contentFolder from '../../../assets/landingpage/content-media-folder.png';
import analyzeData from '../../../assets/landingpage/analyze-data.png';
import designerWorking from '../../../assets/landingpage/designer-working.png';
import squiggle from '../../../assets/landingpage/Squiggle Small 03.svg';

const ResourcesSection = () => {
  const resources = [
    {
      icon: contentFolder,
      title: 'Blog',
      description: 'Read Our AI Insights',
      color: '#F8C864',
      link: 'https://blog.vocable.ai/',
      cta: 'Read More'
    },
    {
      icon: designerWorking,
      title: 'Community',
      description: 'Join Our Community',
      color: '#00A7B7',
      link: 'https://community.vocable.ai/join?invitation_token=134f9d229783740438fd41e893e8f60586b09b4a-6ce59293-4998-456c-8ff9-15cb2326a1d1',
      cta: 'Join Now'
    },
    {
      icon: analyzeData,
      title: 'Product Tutorials',
      description: 'Watch Our Webinars',
      color: '#2247A8',
      link: 'https://www.youtube.com/@Vocable.ai20',
      cta: 'Watch'
    },
  ];

  return (
    <section className={styles.resources}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>
            Work smarter. Create better. Grow faster.
          </h2>
          <img src={squiggle} alt="squiggle" className={styles.squiggle} />
          <p className={styles.subtitle}>
            Access our community, resources and training webinars to make the
            most of Vocable.
          </p>
        </div>

        <div className={styles.cards}>
          {resources.map((resource, index) => (
            <div
              key={index}
              className={styles.card}
              style={{ '--border-color': resource.color }}
            >
              <div className={styles.imageWrapper}>
                <img src={resource.icon} alt={resource.title} />
              </div>
              <h3 className={styles.cardTitle}>{resource.title}</h3>
              <p className={styles.description}>{resource.description}</p>
              <a href={resource.link} className={styles.learnMore} target="_blank">
                {resource.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResourcesSection;
